export type PostedBy = "any" | "owner" | "agent";

interface Props {
  value: PostedBy;
  onChange: (v: PostedBy) => void;
  /** Compact: smaller, no surrounding label — for tight inline contexts. */
  compact?: boolean;
}

const OPTIONS: Array<{ value: PostedBy; label: string; title: string }> = [
  { value: "any", label: "All", title: "Show every listing regardless of who posted it" },
  { value: "owner", label: "Owner", title: "Only listings posted by the property owner (private)" },
  { value: "agent", label: "Agent", title: "Only listings posted by another agency" },
];

export function PostedByToggle({ value, onChange, compact = false }: Props) {
  const sizeCls = compact
    ? "text-[10px] px-1.5 py-0.5"
    : "text-[11px] px-2 py-1";
  return (
    <div className="inline-flex items-center gap-2">
      {!compact && (
        <span className="text-[10px] uppercase tracking-wider text-slate-500">
          Posted by
        </span>
      )}
      <div
        role="radiogroup"
        aria-label="Filter matches by who posted the listing"
        className="inline-flex rounded-md bg-white/[0.03] ring-1 ring-white/10 p-0.5"
      >
        {OPTIONS.map((opt) => {
          const active = opt.value === value;
          return (
            <button
              key={opt.value}
              type="button"
              role="radio"
              aria-checked={active}
              title={opt.title}
              onClick={() => onChange(opt.value)}
              className={`${sizeCls} rounded font-medium transition-colors ${
                active
                  ? "bg-accent-500/20 text-accent-200 ring-1 ring-accent-400/30"
                  : "text-slate-400 hover:text-slate-200"
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
